"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExclamationIcon = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _ref =
/*#__PURE__*/
(0, _jsx2["default"])("svg", {
  width: "57",
  height: "58",
  viewBox: "0 0 57 58",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, (0, _jsx2["default"])("circle", {
  cx: "28",
  cy: "28",
  r: "28",
  fill: "#FAEDE7"
}), (0, _jsx2["default"])("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29 3.75C14.5024 3.75 2.75 15.5024 2.75 30C2.75 44.4976 14.5024 56.25 29 56.25C43.4976 56.25 55.25 44.4976 55.25 30C55.25 15.5024 43.4976 3.75 29 3.75ZM1 30C1 14.5359 13.5359 2 29 2C44.4641 2 57 14.5359 57 30C57 45.4641 44.4641 58 29 58C13.5359 58 1 45.4641 1 30Z",
  fill: "#33174D"
}), (0, _jsx2["default"])("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.7481 37.5981C28.2786 37.5981 27.8981 37.2176 27.8981 36.7481V12.4481C27.8981 11.9787 28.2786 11.5981 28.7481 11.5981C29.2175 11.5981 29.5981 11.9787 29.5981 12.4481V36.7481C29.5981 37.2176 29.2175 37.5981 28.7481 37.5981Z",
  fill: "#33164C"
}), (0, _jsx2["default"])("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.7481 47.5981C28.2786 47.5981 27.8981 47.2176 27.8981 46.7481L27.8981 43.4481C27.8981 42.9787 28.2786 42.5981 28.7481 42.5981C29.2175 42.5981 29.5981 42.9787 29.5981 43.4481L29.5981 46.7481C29.5981 47.2176 29.2175 47.5981 28.7481 47.5981Z",
  fill: "#33164C"
}));

var ExclamationIcon = function ExclamationIcon() {
  return _ref;
};

exports.ExclamationIcon = ExclamationIcon;